import { useLocation } from 'react-router-dom'

import { UserBox } from 'shared/components/molecules/UserBox/UserBox';

import { headerContent } from './utils/headerContent';

import {
  Breadcrumb,
  Container,
  Content,
} from './_header';

import { pathnameType } from './interfaces';

export const Header: React.FC = () => {
  const location = useLocation();
  const { pathname } = location;
  const path = `/${pathname.split('/')[1]}`

  const content = headerContent[path as pathnameType]

  return (
    <Container path={pathname}>
      <Content>
        <div className="header">
          <Breadcrumb path={pathname}>
            {content?.image_url && (
              <img
                src={content?.image_url}
                alt={content?.title}
              />
            )}
            <h1>
              {content?.title}
            </h1>
          </Breadcrumb>

          <UserBox />
        </div>
      </Content>
    </Container>
  );
};
